import { render, staticRenderFns } from "./DeleteBoardModal.vue?vue&type=template&id=9059b820&scoped=true"
import script from "./DeleteBoardModal.vue?vue&type=script&lang=js"
export * from "./DeleteBoardModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteBoardModal.vue?vue&type=style&index=0&id=9059b820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9059b820",
  null
  
)

export default component.exports